import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLogout = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M0.5 0.5H1H7V1.5H1.5V12.5H7V13.5H1H0.5V13V1V0.5ZM4.5 6.5H5H11.7929L10.1464 4.85355L9.79289 4.5L10.5 3.79289L10.8536 4.14645L13.3536 6.64645L13.7071 7L13.3536 7.35355L10.8536 9.85355L10.5 10.2071L9.79289 9.5L10.1464 9.14645L11.7929 7.5H5H4.5V6.5Z",
		fill: "#878994"
	})
});
export default SvgLogout;
